<template>
  <v-card class="overflow-hidden v-card v-sheet theme--light mt-0">
    <header-component :headerTitle="headerText" />
     <v-snackbar
      v-model="snackbar.visible" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :location="snackbar.position === 'top' ? 'top' : 'bottom'">
      <v-layout align-center pr-4>
        <v-icon class="pr-3 ml-2" dark large>{{ snackbar.icon }}</v-icon>
        <v-layout column>
          <div>{{ snackbar.text }}</div>
        </v-layout>
      </v-layout>
      <v-btn v-if="snackbar.timeout === 0" icon @click="snackbar.visible = false">
        <v-icon>clear</v-icon>
      </v-btn>
    </v-snackbar>
     <FaqDialog ref="faqDialog" />
  <v-card class="v-card v-sheet theme--light mt-0 overflow-auto v-card-100 dynamic-height-dis-card">
    <v-card-text class="mt-2 pa-0">
      <v-row class="ma-0">
        <v-col cols="12" sm="3" md="3" lg="3" class="text-left">
          <span class="text-align">Organisation Details *</span>
          <div style="line-height: 0.85;">
            <span class="desrciption-text"> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever. </span>
          </div>
        </v-col>
        <v-col cols="12" sm="3" md="3" lg="3" class="text-left">
          <v-text-field hide-details="auto" v-model="organisation_name" label="Organisation Name" variant="outlined" type="text" :disabled="field_disabled"></v-text-field>
        </v-col>
         <v-col cols="12" sm="6" md="6" lg="6" class="text-left">
          <v-text-field hide-details="auto" v-model="address_1" label="Address Line 1" variant="outlined" type="text"></v-text-field>
        </v-col>
      </v-row>
      <v-row class="ma-0">
        <v-col cols="12" sm="3" md="3" lg="3" class="text-left">
        </v-col>
        <v-col cols="12" sm="9" md="9" lg="9" class="text-left">
          <v-text-field hide-details="auto" v-model="address_2" label="Address Line 2" variant="outlined" type="text"></v-text-field>
        </v-col>
      </v-row>
      <v-row class="ma-0">
        <v-col cols="12" sm="3" md="3" lg="3" class="text-left">
        </v-col>
        <v-col cols="12" sm="9" md="9" lg="9" class="text-left">
          <v-row>
            <v-col cols="12" sm="3" md="3" lg="3" class="text-left">
              <v-text-field hide-details="auto" v-model="country" label="Country" variant="outlined" type="text"></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" md="3" lg="3" class="text-left">
              <v-text-field hide-details="auto" v-model="state" label="State" variant="outlined" type="text"></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" md="3" lg="3" class="text-left">
              <v-text-field hide-details="auto" v-model="city" label="City" variant="outlined" type="text"></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" md="3" lg="3" class="text-left">
              <v-text-field hide-details="auto" v-model="pincode" label="Pincode" variant="outlined" type="text"></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row class="ma-0">
        <v-col cols="12" sm="3" md="3" lg="3" class="text-left">
          <span class="text-align">Contact Details *</span>
          <div style="line-height: 0.85;">
            <span class="desrciption-text"> Lorem Ipsum is simply dummy text of the printing and typesetting industry. </span>
          </div>
        </v-col>
        <v-col cols="12" sm="3" md="3" lg="3" class="text-left">
        <v-text-field hide-details="auto" v-model="name" label="name" variant="outlined" type="text"></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3" lg="3" class="text-left">
         <v-text-field hide-details="auto" v-model="email" label="Email" variant="outlined" type="text"></v-text-field>
         </v-col>
        <v-col cols="12" sm="3" md="3" lg="3" class="text-left">
         <v-text-field hide-details="auto" v-model="mobile_number" label="Mobile Number" variant="outlined" type="text"></v-text-field>
        </v-col>
      </v-row>
      <v-row class="ma-0">
        <v-col cols="12" sm="3" md="3" lg="3" class="text-left">
          <span class="text-align">Logo *</span>
          <div style="line-height: 0.85;">
            <span class="desrciption-text"> Lorem Ipsum is simply dummy text of the printing and typesetting industry.  </span>
          </div>
        </v-col>
        <v-col cols="12" sm="9" md="9" lg="9" class="text-left">
            <v-row>
                <v-col cols="12" sm="6" md="6" lg="6" class="text-left">
                    <v-file-input
                            v-model="file"
                            accept="jpg,.jpeg,.png"
                            class="mb-5"
                            variant="outlined" 
                            prepend-inner-icon="mdi-paperclip"
                            prepend-icon="" 
                            hide-details
                            label="Logo Image"
                        >
                        </v-file-input>
                </v-col>
            </v-row>
        </v-col>
      </v-row>
      <v-row class="ma-0">
        <v-col cols="12" sm="3" md="3" lg="3" class="text-left">
          <span class="text-align">Product Selection (RIA/RIMS/ASA) *</span>
           <div style="line-height: 0.85;">
            <span class="desrciption-text">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever. </span>
          </div>
        </v-col>
        <v-col cols="12" sm="9" md="9" lg="9" class="text-left">
            <v-row>
                <v-col cols="12" sm="6" md="6" lg="6" class="text-left">
                 <v-autocomplete v-model="product_selection" :items="product_selection_items" label="Select Product Selection" variant="outlined" :disabled="field_disabled" multiple closable-chips chips></v-autocomplete>
                </v-col>
            </v-row>
        </v-col>
      </v-row>
      <v-row class="ma-0">
        <v-col cols="12" sm="3" md="3" lg="3" class="text-left">
          <span class="text-align">Optional Modules Selection *</span>
          <div style="line-height: 0.85;">
            <span class="desrciption-text">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever.</span>
          </div>
        </v-col>
        <v-col cols="12" sm="9" md="9" lg="9" class="text-left">
            <v-row>
                <v-col cols="12" sm="6" md="6" lg="6" class="text-left">
                 <v-autocomplete v-model="module_selection" :items="module_selection_items" label="Select Product Selection" variant="outlined" :disabled="field_disabled" multiple closable-chips chips></v-autocomplete>
                </v-col>
            </v-row>
        </v-col>
      </v-row>
      <v-row class="ma-0">
        <v-col cols="12" sm="3" md="3" lg="3" class="text-left">
          <span class="text-align">FAQ Contect *</span>
          <div style="line-height: 0.85;">
            <span class="desrciption-text">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever.</span>
          </div>
        </v-col>
        <v-col cols="12" sm="9" md="9" lg="9" class="text-left">
            <v-row>
                <v-col cols="12" sm="6" md="6" lg="6" class="text-left">
                    <div style="position: relative; display: inline-block; width: 100%;">
                    <v-file-input
                            v-model="faq_file"
                            accept="jpg,.jpeg,.png"
                            class="mb-5"
                            variant="outlined" 
                            prepend-inner-icon="mdi-paperclip"
                            prepend-icon="" 
                            hide-details
                            label="Upload FAQ"
                        >
                        </v-file-input>
                         <a href="#" class="link-text" style="position: absolute; right: 5px;; bottom: 0px" @click="faqOpenDialog">View BB Format</a>
                    </div>
                </v-col>
            </v-row>
        </v-col>
      </v-row>
      <v-row class="ma-0">
        <v-col cols="12" sm="3" md="3" lg="3" class="text-left">
          <span class="text-align">Support Contact *</span>
          <div style="line-height: 0.85;">
            <span class="desrciption-text">Lorem Ipsum is simply dummy text of the printing and typesetting industry. </span>
          </div>
        </v-col>
        <v-col cols="12" sm="9" md="9" lg="9" class="text-left">
            <v-row>
                <v-col cols="12" sm="6" md="6" lg="6" class="text-left">
                    <v-text-field hide-details="auto" v-model="support_email" label="Email ID" variant="outlined" type="text"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6" lg="6" class="text-left">
                    <v-text-field hide-details="auto" v-model="support_phone" label="Phone Number" variant="outlined" type="text"></v-text-field>
                </v-col>
            </v-row>
        </v-col>
      </v-row>
      <v-row class="ma-0">
        <v-col cols="12" sm="3" md="3" lg="3" class="text-left">
          <span class="text-align">FTA Activity Closure Method *</span>
          <div style="line-height: 0.85;">
            <span class="desrciption-text">Lorem Ipsum is simply dummy text of the printing and typesetting industry. </span>
          </div>
        </v-col>
        <v-col cols="12" sm="9" md="9" lg="9" class="text-left">
            <v-row>
                <v-col cols="12" sm="4" md="4" lg="4" class="text-left">
                    <v-autocomplete v-model="asm_method" :items="asm_method_items" label="Select ASM Method" variant="outlined" multiple closable-chips chips></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="4" md="4" lg="4" class="text-left">
                    <v-autocomplete v-model="service_method" :items="service_method_items" label="Select Service Method" variant="outlined" multiple closable-chips chips></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="4" md="4" lg="4" class="text-left">
                    <v-autocomplete v-model="logistics_method" :items="logistics_method_items" label="Select Logistics Method" variant="outlined" multiple closable-chips chips></v-autocomplete>
                </v-col>
            </v-row>
        </v-col>
      </v-row>
      <v-row class="ma-0">
        <v-col cols="12" sm="3" md="3" lg="3" class="text-left">
          <span class="text-align">Select Recovery Bench Price *</span>
          <div style="line-height: 0.85;">
            <span class="desrciption-text">Lorem Ipsum is simply dummy text of the printing and typesetting industry. </span>
          </div>
        </v-col>
        <v-col cols="12" sm="9" md="9" lg="9" class="text-left">
            <v-row>
                <v-col cols="12" sm="6" md="6" lg="6" class="text-left">
                 <v-autocomplete v-model="bench_price" :items="bench_price_items" label="Select Recovery Benchmark Price" variant="outlined"></v-autocomplete>
                </v-col>
            </v-row>
        </v-col>
      </v-row>
      <v-row class="ma-0">
        <v-col cols="12" sm="3" md="3" lg="3" class="text-left">
          <span class="text-align">PRD Creation Method *</span>
          <div style="line-height: 0.85;">
            <span class="desrciption-text">Lorem Ipsum is simply dummy text of the printing and typesetting industry. </span>
          </div>
        </v-col>
        <v-col cols="12" sm="9" md="9" lg="9" class="text-left">
            <v-row>
                <v-col cols="12" sm="4" md="4" lg="4" class="text-left">
                    <v-autocomplete v-model="transfer_method" :items="transfer_method_items" label="Select Transfer Method" variant="outlined"></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="4" md="4" lg="4" class="text-left">
                    <v-autocomplete v-model="repair_method" :items="repair_method_items" label="Select Repair Method" variant="outlined"></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="4" md="4" lg="4" class="text-left">
                    <v-autocomplete v-model="replacement_method" :items="replacement_method_items" label="Select Replacemnet Method" variant="outlined"></v-autocomplete>
                </v-col>
            </v-row>
        </v-col>
      </v-row>
      <v-row class="ma-0">
        <v-col cols="12" sm="3" md="3" lg="3" class="text-left">
          <span class="text-align">Liquidation Channel *</span>
          <div style="line-height: 0.85;">
            <span class="desrciption-text">Lorem Ipsum is simply dummy text of the printing and typesetting industry. </span>
          </div>
        </v-col>
        <v-col cols="12" sm="9" md="9" lg="9" class="text-left">
            <v-row>
                <v-col cols="12" sm="6" md="6" lg="6" class="text-left">
                 <v-autocomplete v-model="liquidation_channel" :items="liquidation_channel_items" label="Select Liquidation Channel" variant="outlined" multiple closable-chips chips></v-autocomplete>
                </v-col>
            </v-row>
        </v-col>
      </v-row>
      <v-row class="ma-0">
        <v-col cols="12" sm="3" md="3" lg="3" class="text-left">
          <span class="text-align">Price Descovery method *</span>
          <div style="line-height: 0.85;">
            <span class="desrciption-text">Lorem Ipsum is simply dummy text of the printing and typesetting industry. </span>
          </div>
        </v-col>
        <v-col cols="12" sm="9" md="9" lg="9" class="text-left">
            <v-row>
                <v-col cols="12" sm="6" md="6" lg="6" class="text-left">
                 <v-autocomplete v-model="discovery_method" :items="discovery_method_items" label="Select Price Discovery Method" variant="outlined" multiple closable-chips chips></v-autocomplete>
                </v-col>
            </v-row>
        </v-col>
      </v-row>
      <v-row class="ma-0">
        <v-col cols="12" sm="3" md="3" lg="3" class="text-left">
          <span class="text-align">Bidding method *</span>
          <div style="line-height: 0.85;">
            <span class="desrciption-text">Lorem Ipsum is simply dummy text of the printing and typesetting industry. </span>
          </div>
        </v-col>
        <v-col cols="12" sm="9" md="9" lg="9" class="text-left">
            <v-row>
                <v-col cols="12" sm="6" md="6" lg="6" class="text-left">
                 <v-autocomplete v-model="bidding_method" :items="bidding_method_items" label="Select Bidding Method" variant="outlined"></v-autocomplete>
                </v-col>
            </v-row>
        </v-col>
      </v-row>
      <v-row class="ma-0">
        <v-col cols="12" sm="3" md="3" lg="3" class="text-left">
          <span class="text-align">Liquidation Benchmarck Price *</span>
          <div style="line-height: 0.85;">
            <span class="desrciption-text">Lorem Ipsum is simply dummy text of the printing and typesetting industry. </span>
          </div>
        </v-col>
        <v-col cols="12" sm="9" md="9" lg="9" class="text-left">
            <v-row>
                <v-col cols="12" sm="6" md="6" lg="6" class="text-left">
                 <v-autocomplete v-model="liq_benchmark_price" :items="liq_benchmark_price_items" label="Select Liquidation Benchmark Price Method" variant="outlined"></v-autocomplete>
                </v-col>
            </v-row>
        </v-col>
      </v-row>
      <v-row class="ma-0">
        <v-col cols="12" sm="3" md="3" lg="3" class="text-left">
          <span class="text-align">Tour Plan Date Range *</span>
          <div style="line-height: 0.85;">
            <span class="desrciption-text">Lorem Ipsum is simply dummy text of the printing and typesetting industry. </span>
          </div>
        </v-col>
        <v-col cols="12" sm="9" md="9" lg="9" class="text-left">
            <v-row>
                <v-col cols="12" sm="6" md="6" lg="6">
                  <v-row>
                    <v-col cols="12" sm="6" md="6" lg="6" class="text-left">
                      <div class="d-flex justify-center">
                      <v-date-input
                        v-model="start_date"
                        label="From Date"
                        variant="outlined"
                        prepend-icon=""
                        prepend-inner-icon="$calendar"
                        class="start-date_style"
                      ></v-date-input>
                    </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" lg="6" class="text-left">
                      <div class="d-flex justify-center">
                      <v-date-input
                        v-model="end_date"
                        label="End Date"
                        variant="outlined"
                        prepend-icon=""
                        prepend-inner-icon="$calendar"
                        class="start-date_style"
                      ></v-date-input>
                    </div>
                    </v-col>
                  </v-row>
                </v-col>
            </v-row>
        </v-col>
      </v-row>
      <v-row class="ma-0">
        <v-col cols="12" sm="3" md="3" lg="3" class="text-left">
          <span class="text-align">Tour Plan Task *</span>
          <div style="line-height: 0.85;">
            <span class="desrciption-text">Lorem Ipsum is simply dummy text of the printing and typesetting industry. </span>
          </div>
        </v-col>
        <v-col cols="12" sm="9" md="9" lg="9" class="text-left">
            <v-row>
                <v-col cols="12" sm="6" md="6" lg="6" class="text-left">
                 <v-autocomplete v-model="tour_plan_task" :items="tour_plan_task_items" label="Select Liquidation Benchmark Price Method" variant="outlined" multiple closable-chips chips></v-autocomplete>
                </v-col>
            </v-row>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
  <div>
  <v-card-actions>
    <v-spacer></v-spacer>
    <v-btn color="primary" variant="flat" class="mt-2 text-none" @click="CreateGeneralSettings" :disabled="!isFormValid"> Save & Proceed</v-btn>
  </v-card-actions>
  </div>
  </v-card>
</template>

<script setup>
import HeaderComponent from "@/components/commoncomponents/HeaderComponent.vue";
import FaqDialog from "@//components/api/v2/ClientConfigurationMasters/FaqDialog.vue";
import { ref, reactive, shallowRef, onMounted, getCurrentInstance, computed } from "vue";
const { proxy } = getCurrentInstance();
const headerText = "General Settings";
const snackbar = reactive({
  color: null,
  icon: null,
  mode: null,
  position: "top",
  text: null,
  timeout: 7500,
  title: null,
  visible: false,
})
const organisation_name = ref('')
const address_1 = ref('')
const address_2 = ref('')
const country = ref('')
const state = ref('')
const city = ref('')
const pincode = ref('')
const name = ref('')
const email = ref('')
const mobile_number = ref('')
const file = ref(null)
const product_selection = ref(null)
const product_selection_items = ref(['RIA', 'RIMS', 'ASA'])
const module_selection = ref(null)
const module_selection_items = ref(['RIA', 'RIMS', 'ASA'])
const faq_file = ref(null)
const support_email = ref('')
const support_phone = ref('')
const asm_method = ref(null)
const asm_method_items = ref([])
const service_method = ref(null)
const service_method_items = ref([])
const logistics_method = ref(null)
const logistics_method_items = ref([])
const bench_price = ref(null)
const bench_price_items = ref([])
const transfer_method = ref(null)
const transfer_method_items = ref([])
const repair_method = ref(null)
const repair_method_items = ref([])
const replacement_method = ref(null)
const replacement_method_items = ref([])
const liquidation_channel = ref(null)
const liquidation_channel_items = ref([])
const discovery_method = ref(null)
const discovery_method_items = ref([])
const bidding_method = ref(null)
const bidding_method_items = ref([])
const liq_benchmark_price = ref(null)
const liq_benchmark_price_items = ref([])
const start_date = shallowRef(null)
const end_date = shallowRef(null)
const tour_plan_task = ref(null)
const tour_plan_task_items = ref([])
const field_disabled = ref(false)

const isFormValid = computed(() => {
  return (
    file.value &&
    faq_file.value &&
    support_email.value &&
    support_phone.value &&
    address_1.value &&
    address_2.value &&
    country.value &&
    state.value &&
    city.value &&
    pincode.value &&
    name.value &&
    email.value &&
    mobile_number.value &&
    asm_method.value.length > 0 &&
    service_method.value.length > 0 &&
    logistics_method.value.length > 0 &&
    tour_plan_task.value.length > 0 &&
    bench_price.value &&
    bidding_method.value &&
    liq_benchmark_price.value &&
    start_date.value &&
    end_date.value &&
    transfer_method.value &&
    repair_method.value &&
    liquidation_channel.value.length > 0 &&
    discovery_method.value.length > 0
  );
});
const faqDialog = ref(null)
onMounted(() => {  
    getSupprtData();
    getAccountData();
    getDropdownData();
    getProductList();
});

const faqOpenDialog = () => {
  faqDialog.value.open();
}

const getSupprtData = () => {
  proxy.$httpSecured
  .get(`/api/v2/general_settings/available_options`)
  .then(response => {
      if(response.data) {
          asm_method_items.value = service_method_items.value = logistics_method_items.value = response.data.fta_methods;
          bench_price_items.value = liq_benchmark_price_items.value = response.data.benchmark_prices;
          transfer_method_items.value = repair_method_items.value = replacement_method_items.value = response.data.prd_methods;
          liquidation_channel_items.value = response.data.liquidation_channels;
          discovery_method_items.value = response.data.price_discovery_methods;
          bidding_method_items.value = response.data.bidding_methods;
          tour_plan_task_items.value = response.data.tour_plan_tasks;
      }else{
          proxy.$toast.error("No Data Found");
      }
  })
  .catch(error => {
      proxy.$toast.error(error.response.data.message);
  })
}
const getDropdownData = () => {
        proxy.$httpSecured
        .get(`/api/v2/account_configurations/available_modules`)
        .then(response => {
            if(response.data) {
               module_selection_items.value = response.data.modules;
               getProductList();
            }else{
                proxy.$toast.error("No Data Found");
            }
        })
        .catch(error => {
            proxy.$toast.error("Something went wrong from Network" + error);
        })
    }
    const getProductList = () => {
        proxy.$httpSecured
        .get(`/api/v2/account_configurations/product_options`)
        .then(response => {
            if(response.data) {
                product_selection_items.value = response.data.products;
            }else{
                proxy.$toast.error("No Data Found");
            }
        })
        .catch(error => {
            proxy.$toast.error(error.response.data.message);
        })
    }
const getAccountData = () => {
  proxy.$httpSecured
  .get(`/api/v2/account_configurations`)
  .then(response => {
      if(response.data) {
        field_disabled.value = true;
        organisation_name.value = response.data.account_configurations[0].organization_name;
        product_selection.value = response.data.account_configurations[0].selected_products;
        module_selection.value = response.data.account_configurations[0].licensed_modules;
        address_1.value = response.data.account_configurations[0].address.address_line_1;
        address_2.value = response.data.account_configurations[0].address.address_line_2;
        country.value = response.data.account_configurations[0].address.country;
        state.value = response.data.account_configurations[0].address.state;
        city.value = response.data.account_configurations[0].address.city;
        pincode.value = response.data.account_configurations[0].address.pincode;
        name.value = response.data.account_configurations[0].contact.name;
        email.value = response.data.account_configurations[0].contact.email;
        mobile_number.value = response.data.account_configurations[0].contact.mobile;
      }else{
          proxy.$toast.error("No Data Found");
      }
  })
  .catch(error => {
      proxy.$toast.error(error.response.data.message);
  })
}
const CreateGeneralSettings = () => {
     const formData = new FormData();
     formData.append('logo_image', file.value);
     formData.append('faq_content', faq_file.value);
     formData.append("general_setting[support_email]", support_email.value);
     formData.append("general_setting[support_phone]", support_phone.value);
     formData.append("general_setting[address_line_1]", address_1.value);
     formData.append("general_setting[address_line_2]", address_2.value);
     formData.append("general_setting[country]", country.value);
     formData.append("general_setting[state]", state.value);
     formData.append("general_setting[city]", city.value);
     formData.append("general_setting[pincode]", pincode.value);
     formData.append("general_setting[contact_name]", name.value);
     formData.append("general_setting[contact_email]", email.value);
     formData.append("general_setting[contact_mobile]", mobile_number.value);
     asm_method.value.forEach(item => {
       formData.append("general_setting[fta_asm_methods][]", item);
     });
     service_method.value.forEach(item => {
       formData.append("general_setting[fta_service_methods][]", item);
     });
     logistics_method.value.forEach(item => {
       formData.append("general_setting[fta_logistics_methods][]", item);
     });
     tour_plan_task.value.forEach(item => {
       formData.append("general_setting[tour_plan_tasks][]", item);
     })
     formData.append("general_setting[recovery_benchmark_price]", bench_price.value);
     formData.append("general_setting[bidding_method]", bidding_method.value);
     formData.append("general_setting[liquidation_benchmark_price]", liq_benchmark_price.value);
     formData.append("general_setting[tour_plan_from_date]", start_date.value);
     formData.append("general_setting[tour_plan_to_date]", end_date.value);
     formData.append("general_setting[prd_transfer_method]", transfer_method.value);
     formData.append("general_setting[prd_repair_method]", repair_method.value);
     formData.append("general_setting[prd_replacement_method]", transfer_method.value);
     liquidation_channel.value.forEach(item => {
       formData.append("general_setting[liquidation_channels][]", item);
     })
     discovery_method.value.forEach(item => {
       formData.append("general_setting[price_discovery_methods][]", item);
     })

     proxy.$httpSecured
     .post(`/api/v2/general_settings`, formData)
     .then(response => {
         if(response.data) {
             snackbar.visible = true;
             snackbar.color = "success";
             snackbar.icon = "mdi-check-circle";
             snackbar.mode = "multi-line";
             snackbar.position = "bottom";
             snackbar.timeout = 3000;
             snackbar.title = "Success";
             snackbar.text = "Data Added Successfully";
             // Clear all form values
              file.value = null;
              faq_file.value = null;
              support_email.value = '';
              support_phone.value = '';
              address_1.value = '';
              address_2.value = '';
              country.value = '';
              state.value = '';
              city.value = '';
              pincode.value = '';
              name.value = '';
              email.value = '';
              mobile_number.value = '';
              asm_method.value = [];
              service_method.value = [];
              logistics_method.value = [];
              tour_plan_task.value = [];
              bench_price.value = '';
              bidding_method.value = '';
              liq_benchmark_price.value = '';
              start_date.value = '';
              end_date.value = '';
              transfer_method.value = '';
              repair_method.value = '';
              liquidation_channel.value = [];
              discovery_method.value = [];
         }else{
             proxy.$toast.error("No Data Found");
         }
     })
     .catch(error => {
         proxy.$toast.error(error.response.data.error);
     })
        
   }
</script>
<style scoped>
  .dynamic-height-dis-card {
    height: calc(var(--vh, 1vh) * 100 - 150px) !important;
  }
  .desrciption-text{
    font-size: 10px;
    color: #888888;
  }
  .link-text{
    text-decoration: underline;
    color: #1976d2;
    cursor: pointer;
    font-size: 14px;
  }
  :deep(.start-date_style .v-field__input input ){
    width: 100% !important;
  }
</style>
